import { faShareFromSquare } from "@fortawesome/pro-regular-svg-icons/faShareFromSquare";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconRepass: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faShareFromSquare} />;
};
